import styled from "@emotion/styled";

import { theme } from "../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.span<{ highlighted?: boolean }>(props => ({
    verticalAlign: "baseline",

    button: {
        boxShadow: props.highlighted ? `0 0 0 2px ${theme(props).valueControls.highlightedBorderColor}` : undefined,
    },
}));

export const ItemContainer = styled.div<{ allowTextWrap?: boolean }>({ cursor: "pointer" }, props =>
    props.allowTextWrap
        ? {
              whiteSpace: "normal",
          }
        : {
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
          }
);

export const Placeholder = styled.div(props => ({
    color: theme(props).typography.secondary.color,
}));

export const HintContainer = styled.div(props => ({
    color: theme(props).typography.inactive.color,
}));
